@if (!isLoading) {
<default-mail-page
	[isInsideModal]="true"
	[mailboxTabs]="mailboxTabs"
	[mailboxAdditionalTabs]="[]"
	[pageType]="pageType"
	[selectedOrderId]="orderID"
	(tabChange)="onPageTypeChange($event)" />
}
